import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/services/classes/loader/loader.service';
import { Restaurant, Address } from 'src/services/classes/models/restaurant';
import { RestaurantService } from 'src/services/data/restaurant/restaurant.service';
import { Router } from '@angular/router';
import { CategoriesService } from 'src/services/data/categories/categories.service';

@Component({
  selector: 'app-home-overlay',
  templateUrl: './home-overlay.component.html',
  styleUrls: ['./home-overlay.component.scss'],
})
export class HomeOverlayComponent implements OnInit {
  restaurantInfo: Restaurant = null;
  selectedOption: 'dine-in' | 'takeout' | null = null;
  takeoutEnabled = false;
  /** True only after we know takeout availability; prevents showing wrong block on first paint */
  takeoutCheckDone = false;
  @Input() source: 'from-main' | 'from-orders' | 'unknown' = 'unknown';

  constructor(
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService,
    private restaurantService: RestaurantService,
    private categoriesService: CategoriesService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getRestaurantInformation();
  }

  getRestaurantInformation() {
    this.loaderService.show();
    this.restaurantInfo = this.restaurantService.fetchRestaurantInformation();
    if (this.restaurantInfo) {
      this.checkTakeoutAvailability();
    } else {
      this.takeoutCheckDone = true;
    }
    this.loaderService.hide();
  }

  checkTakeoutAvailability() {
    this.categoriesService.getAllCategories(this.restaurantInfo.restaurantId).subscribe(
      (res: any) => {
        if (res.status.toLowerCase() !== 'error' && res.data) {
          this.takeoutEnabled = res.data.some((category: any) => category.takeoutEnabled);
        }
        this.takeoutCheckDone = true;
      },
      () => {
        this.takeoutCheckDone = true;
      }
    );
  }

  getAddress(address: Address): String {
    const fullAddress = this.restaurantService.createAddress(address);
    return fullAddress;
  }

  selectOption(option: 'dine-in' | 'takeout') {
    this.selectedOption = option;
    
    // Save the order type to localStorage
    if (option === 'takeout') {
      localStorage.setItem('order-type', 'TAKE_OUT');
      // Behavior depends on where the overlay was opened from
      if (this.source === 'from-orders') {
        // Let the caller (Orders page) handle takeout flow
        this.activeModal.close('TAKE_OUT');
      } else {
        // Default / main page behavior: navigate to dishes
        const restaurantId = this.restaurantInfo?.branchId;
        this.activeModal.dismiss();
        if (restaurantId) {
          this.router.navigateByUrl(`/${restaurantId}/dishes`);
        }
      }
    } else {
      localStorage.setItem('order-type', 'DINE_IN');
    }
  }
}
